import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
// import { colors } from '../../styles';

const styles = css`
`;

function Description({ plan }) {
  return (
    <div className={styles}>
      {
        get(plan, 'description') &&
        <div className="DetailSection">
          <div className="ScrollTarget" id="description" />
          <AccordionToggle
            openOnId="description"
            button={({ contentVisible }) => (
              <div className="container DetailSection_headingWrapper">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Description</h3>
              </div>
            )}
            noToggleDesktop
          >
            <div className="container">
              <div className="d-flex">
                <div className="col-lg-8 mb-5 mx-auto">
                  <div dangerouslySetInnerHTML={SanitizeHtml(get(plan, 'description'))} />
                </div>
              </div>
            </div>
          </AccordionToggle>
        </div>
      }
    </div>
  );
}

Description.propTypes = {
  plan: PropTypes.object.isRequired,
};

Description.defaultProps = {
  community: undefined,
};

export default withData(
  {
    plan: true,
    community: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(Description);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/Description.js